/**
 * Responses component created by karora on 26/05/17.
 */
import 'rxjs/add/operator/switchMap';

import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable, Observer } from 'rxjs';

import { ProfileService } from '../services/profile.service';
import { VoxPopService } from '../services/voxpop.service';
import { VoxResponse } from '../types/response';
import { Topic } from '../types/topic';

@Component({
  moduleId: module.id,
  selector: 'responses',
  templateUrl: './responses.component.html',
  styleUrls: ['./responses.component.css'],
  providers: [VoxPopService],
})


export class ResponsesComponent implements OnInit {
  allResponses: VoxResponse[];
  topic_id: number;
  programme_id: number;
  person_id: number;
  before: number;
  beforeResponses: number[];
  @Input() topic: Topic;
  private _showAll: boolean = false;
  loading: boolean;
  responses: VoxResponse[];
  currentResponse: VoxResponse;
  currentResponseObservable: Observable<VoxResponse>;
  emitter: Observer<VoxResponse>;
  errorMessage: any;

  constructor(
    private voxPopService: VoxPopService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) return;
    this.currentResponseObservable = Observable.create((e: Observer<VoxResponse>) => this.emitter = e);
    this.loading = true;
    this.refreshResponses();
  }

  get showAll(): boolean {
    return this._showAll;
  }

  @Input()
  set showAll(show: boolean) {
    this._showAll = show;
    if (this.allResponses) {
      // Refilter the responses we have
      this.gotResponses(this.allResponses);
    }
  }

  refreshResponses(): void {
    this.route.params.switchMap((params: Params) => this.getResponses(params))
      .subscribe(
        responses => this.gotResponses(responses),
        error => this.errorMessage = <any>error,
      );
  }

  getResponses(params: Params): Observable<VoxResponse[]> {
    this.topic_id = +params['topicid'];
    this.programme_id = +params['programmeid'];
    this.person_id = +params['personid'];
    return this.voxPopService.getResponses(this.programme_id, this.topic_id, this.person_id, this.before);
  }

  gotResponses(responses: VoxResponse[]) {
    console.log("Got " + responses.length + " responses, min duration " + (this.topic && this.topic.min_duration ? this.topic.min_duration : "???"));
    this.loading = false;
    this.allResponses = responses;
    if (this._showAll) {
      this.responses = responses;
    } else {
      let filteredResponses: VoxResponse[] = [];
      for (let i = 0; i < responses.length; i++) {
        if (responses[i].transcript == '[No speech detected]') continue;
        if (this.topic && responses[i].duration < this.topic.min_duration) continue;
        filteredResponses.push(responses[i]);
      }
      this.responses = filteredResponses;
    }
  }


  onSelect(response: VoxResponse): void {
    this.currentResponse = response;
    try {
      this.emitter.next(response);
    } catch (e) {
      console.log("Response.onSelect: " + e.message);
    }
  }

  cancelPlayer(cancel: boolean): void {
    this.onSelect(null);
  }

  responseUpdated(updated: VoxResponse): void {
    this.currentResponse = updated;
    this.refreshResponses();
  }

  publishResponse(response: VoxResponse): void {
    let toPublish = this.currentResponse;
    if (!toPublish || response.id != toPublish.id) {
      toPublish = response;
    }
    toPublish.published = !toPublish.published;
    console.log("Publish " + (toPublish.published ? "on" : "off") + " for " + toPublish.id);
    this.voxPopService.updateResponse(toPublish).subscribe(
      () => this.responseUpdated(toPublish),
    );
  }

  personResponses(response: VoxResponse): void {
    this.router.navigate(['/review/responses/person/', response.person_id]);
  }

  getColorFor(response: VoxResponse): string {
    if (this.currentResponse === response) return '#f8f8f8';
    if (this.errorMessage) return '#ff8080'; // So editor doesn't make me think this can be static
    return '#EEEEEE';
  }

  toggleShowAll(): void {
    this._showAll = !this._showAll;
    this.gotResponses(this.allResponses);
  }

  earlier(): void {
    let before: number = 0;
    try {
      before = this.allResponses[this.allResponses.length - 1].id;
      if (!this.beforeResponses) {
        this.beforeResponses = [];
      }
      this.beforeResponses.push(this.allResponses[0].id)
    } catch (err) {
      console.log(err);
    }
    this.before = before;
    this.refreshResponses();
  }

  later(): void {
    let before: number = 0;
    try {
      before = this.beforeResponses[this.beforeResponses.length - 1] + 1;
      this.beforeResponses = this.beforeResponses.slice(0, -1);
    } catch (err) { }
    this.before = before;
    this.refreshResponses();
  }

  downloadAsCSV(): void {
    let csvData = `"received","name","location","email","phone","transcript","corrected"\n`;
    let responses = this.allResponses;
    for (let i = 0; i < responses.length; i++) {
      let r = responses[i];
      csvData += `"${r.received}","${r.name}","${r.location}","${r.email}","${r.phone}","${r.transcript}","${r.corrected_transcript}"\n`
    }

    let hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvData);
    hiddenElement.target = '_blank';
    hiddenElement.download = 'responses.csv';
    hiddenElement.click();
  }

}
